module.exports = __webpack_public_path__ + "img/ic-bnb.07644a88.svg";